export default __webpack_public_path__ + "static/media/capunipharm.b3fcdc4f.png";